import { render } from "./variationReportList.vue?vue&type=template&id=18750224"
import script from "./variationReportList.vue?vue&type=script&lang=js"
export * from "./variationReportList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__